import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import { periProfileData } from '../../../Services/APIs/profile';

const Questionnaire = ({ setFormOpen, form1Values, setForm2Values, setIsForm1, setFormCompleted, submit }) => {
    const { t, i18n } = useTranslation("f2");
    const [loading, setLoading] = useState(false);
    const isArabic = i18n.language === "ab"; // Check if language is Arabic
    
    const questions = t("questions", { returnObjects: true });
    const questionsInEnglish = [
        "Do you smoke?",
        "Do you suffer from diabetes?",
        "Are you pregnant or just delivered a baby?",
        "Do you have crowns, braces or implants in your mouth?",
        "Do any of your teeth feel loose?"
    ];

    const validationSchema = Yup.object().shape(
        Object.fromEntries(
            questionsInEnglish.map((question) => [question, Yup.string().required(t("required_field"))])
        )
    );

    return (
        <Formik
            initialValues={Object.fromEntries(questionsInEnglish.map((q) => [q, ""]))}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
                setLoading(true);
                try {
                    const questionnaire = Object.entries(values).map(([question, answer]) => ({ [question]: answer }));
                    const info = {
                        uid: JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi,
                        company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
                        ...values,
                        questionnaire,
                        language: i18n.language
                    };
                    setForm2Values(questionnaire);
                    localStorage.setItem("peri-user-questionnaire", JSON.stringify(info));
                    await periProfileData(info);
                    submit();

                } catch (error) {
                    setErrors({ submit: t("submission_error") });
                } finally {
                    setSubmitting(true);
                }
            }}
        >
            {({ values, setFieldValue, isSubmitting, errors }) => (
                <Form 
                    className="flex flex-col items-start p-6 flex-grow"
                    dir={isArabic ? "rtl" : "ltr"}
                >
                    {questions.map((question, index) => (
                        <div key={index} className="mb-4 w-full">
                            <p className={`text-lg mb-2 text-peri-blue font-cera-pro-medium ${isArabic ? 'text-right' : 'text-left'}`}>
                                {question}
                            </p>
                            <div className={`flex gap-4 ${isArabic ? 'flex-row-reverse' : ''}`}>
                                <button
                                    type="button"
                                    onClick={() => setFieldValue(questionsInEnglish[index], 'yes')}
                                    className={`text-base border border-[#7C7F81] uppercase rounded-full transition-all duration-200 font-cera-pro-medium ${values[questionsInEnglish[index]] === 'yes' ? 'bg-red-100' : 'text-[#b2b2b2]'}`}
                                    style={{ height: '50px', width: '166px' }}
                                >
                                    {t("yes")}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setFieldValue(questionsInEnglish[index], 'no')}
                                    className={`text-base border border-[#7C7F81] uppercase rounded-full font-cera-pro-medium transition-all duration-200 ${values[questionsInEnglish[index]] === 'no' ? 'bg-red-100' : 'text-[#b2b2b2]'}`}
                                    style={{ height: '50px', width: '166px' }}
                                >
                                    {t("no")}
                                </button>
                            </div>
                            <ErrorMessage 
                                name={questionsInEnglish[index]} 
                                component="div" 
                                className={`text-red-500 text-sm mt-1 ${isArabic ? 'text-right' : 'text-left'}`} 
                            />
                        </div>
                    ))}

                    <div className="flex flex-col items-center justify-center w-full">
                        <button
                            type="submit"
                            className="mt-6 border border-[#7C7F81] text-peri-blue text-2xl bg-white text-center rounded-lg font-cera-pro-medium font-semibold"
                            style={{ width: '159px', height: '50px', borderRadius: '25px' }}
                            disabled={isSubmitting}
                        >
                            {loading ? 
                                <div className="loader-container my-1">
                                    <div className="loader dark-loader"></div>
                                </div> : 
                                <span>{t("submit-button")}</span>
                            }
                        </button>
                        <ErrorMessage 
                            name="submit" 
                            component="p" 
                            className={`text-red-600 text-base ${isArabic ? 'text-right' : 'text-left'}`} 
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default Questionnaire;